import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { dashboardAPI } from '../../services/inovacaoAPI';

export default function DashboardApetite() {
  const [dados, setDados] = useState(null);
  const [periodo, setPeriodo] = useState('ultimos_3_meses');

  useEffect(() => {
    dashboardAPI.apetiteSetores({ periodo })
      .then(setDados)
      .catch((e) => toast.error(e.response?.data?.detail || 'Erro'));
  }, [periodo]);

  if (!dados) return <div style={{ padding: 32 }}>Carregando…</div>;

  return (
    <div style={{ padding: 32 }}>
      <h1>Dashboard: Apetite por setor</h1>
      <select value={periodo} onChange={(e) => setPeriodo(e.target.value)}
              style={{ padding: 8, marginBottom: 16 }}>
        <option value="ultimos_3_meses">Últimos 3 meses</option>
        <option value="ano_atual">Ano atual</option>
      </select>

      <table style={{ width: '100%', background: '#fff', borderCollapse: 'collapse' }}>
        <thead style={{ background: '#f7f7f7' }}>
          <tr>
            <th style={{ padding: 12, textAlign: 'left' }}>Setor</th>
            <th style={{ padding: 12, textAlign: 'left' }}>Score</th>
            <th style={{ padding: 12, textAlign: 'left' }}>Demandas</th>
            <th style={{ padding: 12, textAlign: 'left' }}>Aprovadas</th>
            <th style={{ padding: 12, textAlign: 'left' }}>Projetos concluídos</th>
            <th style={{ padding: 12, textAlign: 'left' }}>Tempo médio aprovação</th>
            <th style={{ padding: 12, textAlign: 'left' }}>Horas economizadas</th>
          </tr>
        </thead>
        <tbody>
          {dados.setores.map((s) => (
            <tr key={s.setor.id} style={{ borderTop: '1px solid #eee' }}>
              <td style={{ padding: 12 }}>{s.setor.nome}</td>
              <td style={{ padding: 12 }}>
                <div style={{ display: 'inline-block', minWidth: 36, textAlign: 'center',
                              padding: '4px 8px', background: `hsl(${s.score_engajamento * 1.2}, 70%, 50%)`,
                              color: '#fff', borderRadius: 12, fontWeight: 600 }}>
                  {s.score_engajamento}
                </div>
              </td>
              <td style={{ padding: 12 }}>{s.demandas_criadas}</td>
              <td style={{ padding: 12 }}>{s.demandas_aprovadas}</td>
              <td style={{ padding: 12 }}>{s.projetos_concluidos}</td>
              <td style={{ padding: 12 }}>
                {s.tempo_medio_aprovacao_horas > 0 ? `${s.tempo_medio_aprovacao_horas}h` : '—'}
              </td>
              <td style={{ padding: 12 }}>{s.horas_economizadas}h</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
